import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getToken } from "./utils/Token";

export default function AuthGuard({ redirectTo = "/" }) {
  const [isLoggedIn, setIsLoggedIn] = useState(true); // Assuming user is initially logged in

  useEffect(() => {
    let timer;
    
    // Reset timer function
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        setIsLoggedIn(false); // User is considered logged out after 24 hours of inactivity
        alert("Please login"); // Show alert
      }, 24 * 60 * 60 * 1000); // 24 hours
    };

    // Call resetTimer function on component mount and every time isLoggedIn changes
    resetTimer();

    // Clear timer on component unmount
    return () => clearTimeout(timer);
  }, [isLoggedIn]);

  if (!getToken() || !isLoggedIn) {
    return <Navigate to={redirectTo} replace />;
  }
  
  return <Outlet />;
}
